import {
    get_aperture,
    create_apertura,
    update_apertura,
    delete_apertura,
} from "@/api/api.aperture.js";

const aperture = {
    namespaced: true,

    state: {
        lista: [],
    },

    mutations: {
        SET_LISTA: (state, lista) => { state.lista = lista; },
    },

    actions: {
        carica({ commit }, filtri) {
            return new Promise((resolve, reject) => {
                get_aperture(filtri).then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        crea({ dispatch }, dati) {
            return new Promise((resolve, reject) => {
                create_apertura(dati).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        aggiorna({ dispatch }, { id, dati }) {
            return new Promise((resolve, reject) => {
                update_apertura(id, dati).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        elimina({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                delete_apertura(id).then(resp => {
                    dispatch("carica");
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },
    },

    getters: {
        lista: state => state.lista,
    },
};

export default aperture;
